var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mini-gantt-chart-container" },
    [
      _vm.ganttChartLoading
        ? [_c("div", { staticClass: "loader-round" })]
        : [
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-position": "top",
                          "label-width": "8em",
                          inline: true,
                          size: "small",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { staticStyle: { width: "80px" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "mb-3",
                                attrs: { size: "small", filterable: "" },
                                model: {
                                  value: _vm.timeStepper,
                                  callback: function ($$v) {
                                    _vm.timeStepper = $$v
                                  },
                                  expression: "timeStepper",
                                },
                              },
                              _vm._l(_vm.timeSteppers, function (item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { staticClass: "text-indigo-700 float-right" },
                          [
                            _c("b", [
                              _c("i", [
                                _vm._v(
                                  _vm._s(_vm.$t("general.totalOrders")) +
                                    ": " +
                                    _vm._s(_vm.currentPlanOrdersLen)
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { staticClass: "text-teal-700 float-right" },
                          [
                            _c("b", [
                              _c("i", [
                                _vm._v(
                                  _vm._s(_vm.$t("planning.totalTrucks")) +
                                    ": " +
                                    _vm._s(_vm.trucks.length) +
                                    ","
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.trucks.length >= 1
              ? _c(
                  "div",
                  {
                    ref: "ganttChart",
                    staticClass: "gantt-chart",
                    style: _vm.gcContainerStyle,
                    attrs: { id: "ganttChart" },
                  },
                  [
                    _c(
                      "el-row",
                      {
                        staticClass: "gantt-chart-header",
                        style: _vm.gcHeaderStyle,
                        attrs: { type: "flex" },
                      },
                      [
                        _c("el-col", {
                          staticClass: "left",
                          style: {
                            width: _vm.$isMobile
                              ? _vm.smallLeftWidth + "px"
                              : _vm.leftWidth + "px",
                          },
                        }),
                        _c(
                          "el-col",
                          { staticClass: "right" },
                          _vm._l(_vm.timeList, function (date, dateIndex) {
                            return _c(
                              "div",
                              {
                                key: dateIndex,
                                staticClass: "time-list-container",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "time-list-date",
                                    style: {
                                      left:
                                        _vm.ganttChartCellWidth *
                                          date.timeList[0].counter -
                                        20 +
                                        "px",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(date.date) + " ")]
                                ),
                                _vm._l(
                                  date.timeList,
                                  function (time, timeIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key: timeIndex,
                                        staticClass: "time-list",
                                        style: {
                                          left:
                                            _vm.ganttChartCellWidth *
                                              time.counter +
                                            "px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              position: "absolute",
                                              left: "-20px",
                                            },
                                          },
                                          [_vm._v(_vm._s(time.time))]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      {
                        staticClass: "vertical-lines-header",
                        style: _vm.gcHeaderStyle,
                        attrs: { type: "flex" },
                      },
                      [
                        _c("el-col", { staticClass: "left" }),
                        _c(
                          "el-col",
                          {
                            staticClass: "right",
                            style: {
                              "margin-left": _vm.$isMobile
                                ? _vm.smallLeftWidth + "px"
                                : _vm.leftWidth + "px",
                            },
                          },
                          _vm._l(_vm.timeList, function (date, dateIndex) {
                            return _c(
                              "div",
                              {
                                key: "t" + dateIndex,
                                staticClass: "vertical-lines-container",
                              },
                              _vm._l(date.timeList, function (time, timeIndex) {
                                return dateIndex !== 0 || timeIndex !== 0
                                  ? _c("div", {
                                      key: "t" + timeIndex,
                                      staticClass: "vertical-lines",
                                      style: {
                                        left:
                                          _vm.ganttChartCellWidth *
                                            time.counter +
                                          "px",
                                        height: _vm.trucks.length * 31 + "px",
                                      },
                                    })
                                  : _vm._e()
                              }),
                              0
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _vm._l(_vm.trucks, function (truck, truckIndex) {
                      return _c(
                        "el-row",
                        {
                          key: truckIndex,
                          staticClass: "truck no-gutters",
                          class: _vm.getGCRowClass(truck, truckIndex),
                          style: _vm.getGCRowStyle(truck, truckIndex),
                          attrs: { type: "flex" },
                        },
                        [
                          _vm.truckData[truck]
                            ? _c(
                                "el-col",
                                {
                                  staticClass: "truck-header",
                                  style: {
                                    width: _vm.$isMobile
                                      ? _vm.smallLeftWidth + "px"
                                      : _vm.leftWidth + "px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "selection-container" },
                                    [
                                      _vm.checkSelected(
                                        _vm.truckData[truck]["id"]
                                      )
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content: _vm.$t(
                                                  "planning.tooltip.unselectedTruck"
                                                ),
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass:
                                                  "truck-enable cursor-pointer",
                                                staticStyle: { margin: "4px" },
                                                style: {
                                                  color: _vm.getSelectColor(
                                                    _vm.truckData[truck]["id"]
                                                  ),
                                                },
                                                attrs: { icon: "circle" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.unselectTruck(
                                                      _vm.truckData[truck]["id"]
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content: _vm.$t(
                                                  "planning.tooltip.selectedTruck"
                                                ),
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass:
                                                  "truck-disable cursor-pointer",
                                                staticStyle: { margin: "4px" },
                                                attrs: {
                                                  icon: ["far", "circle"],
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectTruck(
                                                      _vm.truckData[truck]["id"]
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-tooltip",
                                    { attrs: { placement: "left" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "planning.columns.plateNumber"
                                                )
                                              ) +
                                              ": " +
                                              _vm._s(truck.plateNumber || "-")
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "planning.columns.vehicleType"
                                                )
                                              ) +
                                              ": " +
                                              _vm._s(
                                                _vm.truckData[truck]
                                                  .vehicleType || "-"
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "planning.columns.truckType"
                                                )
                                              ) +
                                              ": " +
                                              _vm._s(
                                                _vm.truckData[truck].truckType
                                                  ? "" +
                                                      _vm.truckData[truck]
                                                        .truckType
                                                  : "-"
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "planning.columns.truckCommodityType"
                                                )
                                              ) +
                                              ": " +
                                              _vm._s(
                                                _vm.truckData[truck]
                                                  .truckCommodityType
                                                  ? "" +
                                                      _vm.truckData[truck]
                                                        .truckCommodityType
                                                  : "-"
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "planning.columns.brandName"
                                                )
                                              ) +
                                              ": " +
                                              _vm._s(
                                                _vm.truckData[truck].brandName
                                                  ? "" +
                                                      _vm.truckData[truck]
                                                        .brandName
                                                  : "-"
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "planning.columns.weightCapacity"
                                                )
                                              ) +
                                              ": " +
                                              _vm._s(
                                                _vm.truckData[truck].weight
                                                  ? "" +
                                                      _vm.helper.printThousandDecimal(
                                                        _vm.truckData[truck]
                                                          .weight
                                                      )
                                                  : 0
                                              )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "planning.columns.volumeCapacity"
                                                )
                                              ) +
                                              ": " +
                                              _vm._s(
                                                _vm.truckData[truck].volume
                                                  ? "" +
                                                      _vm.helper.printThousandDecimal(
                                                        parseFloat(
                                                          _vm.truckData[truck]
                                                            .volume
                                                        )
                                                      )
                                                  : 0
                                              )
                                          ),
                                          _c("br"),
                                        ]
                                      ),
                                      _c("font-awesome-icon", {
                                        staticStyle: { "margin-left": "0" },
                                        attrs: { icon: "info-circle" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("span", { staticClass: "title ml-1" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.truckData[truck].plateNumber || "-"
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-col",
                            {
                              staticClass: "truck-timetable",
                              style: {
                                width: _vm.$isMobile
                                  ? "calc(100% - " + _vm.smallLeftWidth + "px)"
                                  : "calc(100% - " + _vm.leftWidth + "px)",
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "current-time",
                                style: { left: _vm.currentTimeLeft + "px" },
                              }),
                              _c(
                                "div",
                                { staticClass: "content" },
                                _vm._l(
                                  _vm.getRoutes(truck),
                                  function (route, routeIndex) {
                                    return _c(
                                      "el-tooltip",
                                      {
                                        key:
                                          "r-" +
                                          route.masterpointId +
                                          "-" +
                                          routeIndex,
                                        style: _vm.getContainerStyles(route),
                                        attrs: { placement: "top" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  "#" +
                                                    _vm._s(routeIndex + 1) +
                                                    " - " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "planning.waypointType." +
                                                          route.waypointType
                                                      )
                                                    )
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.status"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  route.status.toUpperCase()
                                                )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.zone"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  route.zone === ""
                                                    ? "-"
                                                    : route.zone
                                                )
                                              ),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(route.displayAddress)
                                              ),
                                            ]),
                                            _c("hr"),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.start"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("convertTimezone")(
                                                    route.startTime,
                                                    _vm.$timezone
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.travellingTime"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.helper.printThousandDecimal(
                                                    route.time / 60
                                                  )
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.minutes"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    route.status.toUpperCase() ===
                                                      "COMPLETED"
                                                      ? _vm.$t(
                                                          "planning.tooltip.arrivalTime"
                                                        )
                                                      : _vm.$t(
                                                          "planning.tooltip.eta"
                                                        )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("convertTimezone")(
                                                    route.estimateTime,
                                                    _vm.$timezone
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.waitingTime"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.helper.printThousandDecimal(
                                                    route.waitingTime / 60
                                                  )
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.minutes"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.handlingTime"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.helper.printThousandDecimal(
                                                    route.handlingTime / 60
                                                  )
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.minutes"
                                                    )
                                                  )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    route.status.toUpperCase() ===
                                                      "COMPLETED"
                                                      ? _vm.$t(
                                                          "planning.tooltip.end"
                                                        )
                                                      : _vm.$t(
                                                          "planning.tooltip.expectedEnd"
                                                        )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("convertTimezone")(
                                                    route.endTime,
                                                    _vm.$timezone
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("hr"),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.planId"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(_vm._s(route.planId)),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.columns.projectCode"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  route.projectCode
                                                    ? route.projectCode.join(
                                                        ", "
                                                      )
                                                    : ""
                                                )
                                              ),
                                            ]),
                                            _c("div", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.tooltip.shipRefs"
                                                    )
                                                  ) + ": "
                                                ),
                                              ]),
                                              _vm._v(
                                                _vm._s(
                                                  route.shipmentReference
                                                    ? route.shipmentReference.join(
                                                        ", "
                                                      )
                                                    : ""
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cursor-pointer position-absolute",
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "travelling-time",
                                              style: _vm.getRouteStyles(
                                                route,
                                                "travellingTime"
                                              ),
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "waiting-time",
                                                class:
                                                  _vm.getStatusColor(route),
                                                style: _vm.getRouteStyles(
                                                  route,
                                                  "waitingTime"
                                                ),
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "remarks-container d-none",
                                                  },
                                                  [
                                                    route.update
                                                      ? _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "remarks truck-update",
                                                            attrs: {
                                                              icon: "exclamation-circle",
                                                            },
                                                          }
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c("div", {
                                              staticClass: "handling-time",
                                              class: _vm.getStatusColor(route),
                                              style: _vm.getRouteStyles(
                                                route,
                                                "handlingTime"
                                              ),
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "route-index" },
                                              [_vm._v(_vm._s(routeIndex + 1))]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              : _c("div", [
                  _c("p", { staticClass: "no-vehicle" }, [
                    _vm._v(_vm._s(_vm.$t("truck.noVehicle"))),
                  ]),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }